// src/queries/getDatoCmsToken.ts

export const getDatoCmsToken = (): string => {
  // Use a single, clear environment variable for your API token.
  const token = process.env.REACT_APP_DATOCMS_API_TOKEN;

  if (!token) {
    throw new Error(
      'DatoCMS token is not configured. Please create a .env.local file and add REACT_APP_DATOCMS_API_TOKEN="YOUR_TOKEN_HERE"'
    );
  }

  return token;
};